import SignUpForm from "./signUpForm.container";

export default SignUpForm;